<template>
  <div v-if="item">

    <fields-list :item="item" :fields="fields" />
    <div class="save-panel">
      <button class="btn btn-sm btn-success btn-icon mt-4" @click="updateItem">
        <span class="ti-save"></span>Сохранить
      </button>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent } from "../../../plugins/functions";



export default {
  data: () => ({
    cardLink: "feature/card",
    cardSetLink: "feature/update",
    item: null,
    fields: [
      {
        col: "col-8",
        key: "title",
        label: "Название",
        type: "field",
        textType: "text",
        isMultiLang:true
      },
 
    ],
  }),

  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);

    if (this.item && this.item.parent_id){
      this.fields.push(
                {
                    col: "col-8",
                    key: "is_filter",
                    label: "Использовать в фильтрах",
                    type: "checkbox",
                    textType: "text",
            }
      );
      this.fields.push(
              {
                    col: "col-8",
                    key: "is_main",
                    label: "Использовать в главном описании товара",
                    type: "checkbox",
                    textType: "text",
          }
      );
      
    }
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    updateItem() {
      this.cardUpdate(this.cardSetLink, this.item);
    },
  },
};
</script>
<style>
</style>
